// extracted by mini-css-extract-plugin
export default {"QuickResponse":"QuickResponseContainer_QuickResponse__+8TnF"};